import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { FaPlay } from 'react-icons/fa';

const Gallery = () => {
  const { t } = useLanguage();

  const galleryImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/2n9vqk2w_Workshop%20Front.png',
      category: t('gallery.facilities'),
      title: 'Workshop Storefront'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/0s9av5ex_Workshop10.jpg',
      category: t('gallery.facilities'),
      title: 'Multi-Bay Service Floor'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/fyzgh57f_Workshop3.jpeg',
      category: t('gallery.facilities'),
      title: 'Our Workshop'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/v0rye9tu_Workshop2.jpeg',
      category: t('gallery.process'),
      title: 'European Car Repair'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/7itqiol8_Workshop15.jpeg',
      category: t('gallery.process'),
      title: 'Mercedes-Benz G-Class Brabus Service'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/pthkqp2x_Workshop16.jpeg',
      category: t('gallery.process'),
      title: 'Engine Cylinder Head Repair'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/iz72ui16_Workshop17.jpeg',
      category: t('gallery.process'),
      title: 'Ferrari F430 Service'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/dfgwra1l_Workshop18.jpeg',
      category: t('gallery.process'),
      title: 'Porsche Cayman Maintenance'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/paabcr14_Workshop7.jpg',
      category: t('gallery.process'),
      title: 'BMW Transmission Overhaul'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/x1kreg6m_Workshop8.jpg',
      category: t('gallery.hybrid'),
      title: 'Volvo XC90 Hybrid Inverter Repair'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/n5f3p6pk_Workshop9.jpg',
      category: t('gallery.hybrid'),
      title: 'Toyota Camry Hybrid Battery Service'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/8uizlpnp_New%202.jpeg',
      category: t('gallery.hybrid'),
      title: 'Hybrid Battery Service'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/44zt2kut_Workshop5.jpeg',
      category: t('gallery.equipment'),
      title: 'Advanced Diagnostics on Mercedes-Benz'
    }
  ];

  const videoUrl1 = 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/4ano2962_Company%20introduction.mp4';

  return (
    <div className="min-h-screen" data-testid="gallery-page">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center bg-cover bg-center"
        style={{ backgroundImage: 'url(https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/fyzgh57f_Workshop3.jpeg)' }}
      >
        <div className="absolute inset-0 bg-dark-navy/80"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full text-center">
          <h1 className="font-cabinet font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white mb-4">
            {t('gallery.title')}
          </h1>
          <p className="text-lg text-gray-200">{t('gallery.heading')}</p>
        </div>
      </section>

      {/* Company Introduction Videos */}
      <section className="py-20 bg-dark-navy" data-testid="video-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-400/20 mb-4">
              <FaPlay className="text-blue-400 ml-1" size={24} />
            </div>
            <h2 className="font-cabinet font-extrabold text-3xl sm:text-4xl text-white mb-3 tracking-tight">
              COMPANY INTRODUCTION
            </h2>
            <p className="text-gray-300 text-base">
              Take a virtual tour of our workshop and meet our team
            </p>
          </div>
          <div className="max-w-5xl mx-auto">
            <div className="relative aspect-video bg-black overflow-hidden border border-white/10 shadow-2xl">
              <video
                controls
                className="w-full h-full object-cover"
                data-testid="company-intro-video"
                poster="https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/fyzgh57f_Workshop3.jpeg"
              >
                <source src={videoUrl1} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-cabinet font-bold text-3xl text-dark-navy mb-3">
              Workshop Photos
            </h2>
            <p className="text-gray-600 text-base">A glimpse of our facilities and work</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {galleryImages.map((image, index) => (
              <div 
                key={index} 
                data-testid={`gallery-image-${index}`}
                className="group relative h-80 overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow cursor-pointer"
              >
                <img 
                  src={image.url} 
                  alt={image.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-navy/90 via-dark-navy/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <span className="inline-block px-3 py-1 bg-royal-blue text-white text-xs font-semibold mb-2">
                      {image.category}
                    </span>
                    <h3 className="font-cabinet font-bold text-lg text-white">
                      {image.title}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
